<template>
  <div>
    <yacht-modal-select
      v-model="yacht"
      :dialog-visible.sync="yachtModalSelectVisible"
      label="Yachts"
      force-dialog
      dialog-only
      @submit="openRepositoryTaskSelectDialog"
    />

    <repository-task-modal-select
      ref="repositoryTaskModalSelect"
      v-model="serviceRepositoryTask"
      :dialog-visible.sync="repositoryTaskModalSelectVisible"
      :yacht-id="yacht ? yacht.id : null"
      dialog-title="Select Wintering Task"
      :dialog-subtitle="yacht ? 'Yacht: ' + yacht.name : null"
      data-vv-as="Task"
      name="task"
      force-dialog
      dialog-only
      wintering
      @submit="openServiceTaskFinishDialog"
    />

    <service-task-wintering-finish-dialog
      v-if="yacht && serviceRepositoryTask"
      :visible.sync="serviceTaskFinishDialogVisible"
      :service-repository-task="serviceRepositoryTask"
      :yacht="yacht"
      @serviceTask:created="serviceTaskCreated"
    />
  </div>
</template>

<script>
  import YachtModalSelect from '@/components/service/helpers/YachtModalSelect'
  import RepositoryTaskModalSelect from '@/components/service/helpers/RepositoryTaskModalSelect'
  import ServiceTaskWinteringFinishDialog from '@/components/service/serviceTasks/ServiceTaskWinteringFinishDialog'

  export default {
    name: 'AddNewWinteringTask',
    components: {
      ServiceTaskWinteringFinishDialog,
      RepositoryTaskModalSelect,
      YachtModalSelect
    },
    props: {
      value: Boolean
    },
    data() {
      return {
        assignedTo: [],
        yacht: null,
        serviceRepositoryTask: null,
        hoursSpent: null,
        isTimeLog: false,
        repositoryTaskModalSelectVisible: false,
        yachtModalSelectVisible: false,
        serviceTaskFinishDialogVisible: false,
        confirmDialog: false,
        submitting: false
      }
    },
    computed: {
      serviceTaskFinishDialogSubtitle() {
        return this.serviceRepositoryTask ? this.serviceRepositoryTask.title + ' for ' + this.yacht.name : ''
      }
    },
    watch: {
      value(val) {
        if (val) {
          this.openYachtSelect()
        }
      },
      serviceTaskFinishDialogVisible(val) {
        if (!val) {
          this.serviceRepositoryTask = null
          this.assignedTo = []
          this.hoursSpent = null
        }
      }
    },
    updated() {
      this.updateValue()
    },
    methods: {
      updateValue() {
        const addingNewWinteringTask = this.yachtModalSelectVisible || this.repositoryTaskModalSelectVisible || this.serviceTaskFinishDialogVisible

        if (addingNewWinteringTask !== this.value) this.$emit('input', addingNewWinteringTask)
      },
      openYachtSelect() {
        // reset data
        this.yacht = null
        this.serviceRepositoryTask = null
        // close others
        this.repositoryTaskModalSelectVisible = false
        this.serviceTaskFinishDialogVisible = false
        // open yacht select dialog
        this.yachtModalSelectVisible = true
      },
      openRepositoryTaskSelectDialog() {
        // reset data
        this.serviceRepositoryTask = null
        // close others
        this.yachtModalSelectVisible = false
        this.serviceTaskFinishDialogVisible = false
        // open wintering service task select
        this.repositoryTaskModalSelectVisible = true
      },
      openServiceTaskFinishDialog() {
        this.serviceTaskFinishDialogVisible = true
      },
      serviceTaskCreated(serviceTask) {
        this.serviceRepositoryTask = null
        this.$refs.repositoryTaskModalSelect.fetchRepositoryTasks()

        this.$emit('serviceTask:created', serviceTask)
      }
    }
  }
</script>
